import { gql, useQuery } from '@apollo/client'

const CHECK_LIVE_PRODUCT = gql`
  query GetLiveProduct($id: ID!) {
    node(id: $id) {
      ... on Product {
        id
        title
        variants(first: 20) {
          edges {
            node {
              id
              title
              availableForSale
              currentlyNotInStock
              quantityAvailable
              sku
            }
          }
        }
      }
    }
  }
`

export const useGetLiveProduct = ({ id }) => {
  const { data, loading, error } = useQuery(CHECK_LIVE_PRODUCT, {
    variables: {
      id,
    },
  })

  return {
    data,
    loading,
    error,
  }
}

const CHECK_PRODUCTS_IN_STOCK = gql`
  query GetLiveProduct($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        availableForSale
      }
    }
  }
`

export const useCheckProductsInStock = ({ ids }) => {
  const { data, loading, error } = useQuery(CHECK_PRODUCTS_IN_STOCK, {
    variables: {
      ids,
    },
  })

  return {
    data,
    loading,
    error,
  }
}
